import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { Field } from 'redux-form';

import AutosuggestField from 'components/fields/AutosuggestField';

import * as validate from 'utils/validate';

import { requestSearchUsers } from 'redux/modules/users';
import { accountLoginFail } from 'redux/modules/account';

const ProductClaimViewItemAssigned = ({
  ID,
  disabled,
  change,
  className,
  actions,
}) => (
  <Field
    className={className}
    id={`${ID}-orderLine.Assigned User Name`}
    name={`${ID}-orderLine.Assigned User Name`}
    component={AutosuggestField}
    placeholder="-Select User-"
    fullWidth
    listWidth="auto"
    disabled={disabled}
    renderSuggestionContent={suggestion => (
      `${suggestion['First Name']} ${suggestion['Last Name']}`
    )}
    renderInputContent={suggestion => (
      `${suggestion['First Name']} ${suggestion['Last Name']}`
    )}
    onSuggestionSelected={(suggestion) => {
      change(`${ID}-orderLine.Selected Assigned User Name`, `${suggestion['First Name']} ${suggestion['Last Name']}`);
      change(`${ID}-orderLine.Assigned User ID`, suggestion.ID);
      return `${suggestion['First Name']} ${suggestion['Last Name']}`;
    }}
    fetchSuggestions={({ value, limit, offset }) => (
      value.length > 0
        ? requestSearchUsers({
          filters: [
            {
              name: 'Role',
              operation: 'nin',
              val: ['Driver', 'System'],
            },
            {
              name: 'Active',
              operation: 'eq',
              val: 'true',
            },
            {
              name: 'Full Name',
              operation: 'startswith',
              val: value,
              case_sensitivity: false,
            },
          ],
          limit,
          offset,
        }).then(res => res.data,
          (error) => {
            if (error.data.error === 'Need authorisation') {
              actions.accountLoginFail();
            }
            return error;
          })
        : requestSearchUsers({
          filters: [
            {
              name: 'Role',
              operation: 'nin',
              val: ['Driver', 'System'],
            },
            {
              name: 'Active',
              operation: 'eq',
              val: 'true',
            },
          ],
          limit,
          offset,
        }).then(res => res.data,
          (error) => {
            if (error.data.error === 'Need authorisation') {
              actions.accountLoginFail();
            }
            return error;
          })
    )}
    validate={[validate.required]}
    onlyConfirmedSelection
  />
);

ProductClaimViewItemAssigned.propTypes = {
  ID: PropTypes.number.isRequired,
  change: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
  className: PropTypes.string,
  actions: PropTypes.shape({
    accountLoginFail: PropTypes.func.isRequired,
  }).isRequired,
};

ProductClaimViewItemAssigned.defaultProps = {
  className: '',
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ accountLoginFail }, dispatch),
});

export default connect(null, mapDispatchToProps)(
  ProductClaimViewItemAssigned,
);



// WEBPACK FOOTER //
// ./src/components/workflow/ProductClaimView/ProductClaimViewItemAssigned.js